<template>    
    <v-card color="#fff" light>
         <v-card-title v-if="title != ''">            
            <h1 class="display-2">{{ title }} </h1> </br>  
            <!-- <code>{{ list }}</code> -->
        </v-card-title>       
        <v-card-text>
            <v-container fluid fill-height grid-list-xl>
                <v-layout row wrap fill-height>
                    <v-flex :class="sizes" v-for="item in filteredList" :key="item.id">
                        <component
                            :is="listitem"
                            :item="item" 
                            :paths="paths" 
                            :tileactions="tileactions">                                
                        </component>
                    </v-flex>
                </v-layout>
            </v-container>            
        </v-card-text>                
    </v-card>
</template>
<script>
    import entitylistitem from "./EntityListItem.vue";
    import adresslistitem from "./AdressListItem.vue";
    import companylistitem from "./CompanyListItem.vue";
    import projectlistitem from "./ProjectListItem.vue";
    import searchmixin from '../../mixins/SearchMixin.js';
    import { mapGetters } from 'vuex';    
    export default {   
    components: {
        companylistitem:companylistitem,
        entitylistitem:entitylistitem,
        adresslistitem:adresslistitem,
        projectlistitem:projectlistitem
    },
    mixins: [
        searchmixin
    ],
    props: [
        'items',
        'list'
    ],
   
    data() {
        return {  
           companylistitem:companylistitem,
           entitylistitem:entitylistitem,
           adresslistitem:adresslistitem,
           projectlistitem:projectlistitem
        }
    },
    computed: {
        tileactions: function(){
            return this.listdata.tileactions
        },
        paths: function() {
            return this.$store.getters['shared/paths']
        },
        listdata: function() {
            return this.$store.getters['lists/' + this.list]
        },
        listitem: function() {
            return this.listdata.listitem
        },
        title: function() {
            return this.listdata.name
        },
        sizes: function() {
            return this.listdata.sizes
        }
            
        
        
    },
    
    methods: {
        
    },
    
    
    
    
}
</script>